// extracted by mini-css-extract-plugin
module.exports = {"container":"GlobalFooter_ContactColumn_container","title":"GlobalFooter_ContactColumn_title","line":"GlobalFooter_ContactColumn_line","link":"GlobalFooter_ContactColumn_link"};